import * as actions from 'actions';
import textEditingMaker from 'reducersMakers/textEditingMaker';

export default textEditingMaker({
  submitType: actions.MAGAZINE_ARTICLE_CREATE,
  submitSuccessType: actions.MAGAZINE_ARTICLE_CREATE_SUCCESS,
  submitErrorType: actions.MAGAZINE_ARTICLE_CREATE_ERROR,
  updateTextType: actions.MAGAZINE_CONTRIBUTE_EDITING_UPDATE_TEXT,
  resetType: actions.MAGAZINE_CONTRIBUTE_EDITING_RESET
});



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/textEditing/magazineContribute/reducer.js
 **/